import { useEffect } from "react";
import { useTheme } from "next-themes";

/**
 * next-themes (class strategy, used by HeroUI + old pages) stays the source of
 * truth; the v2 token system themes via [data-theme] on <html>. This keeps the
 * two in sync. The pre-paint value is set by the inline script in index.html.
 */
export function ThemeBridge() {
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    if (resolvedTheme === "light" || resolvedTheme === "dark") {
      document.documentElement.dataset.theme = resolvedTheme;
    }
  }, [resolvedTheme]);

  return null;
}
